import { CEViewGrantAttributesBase } from './ce-view-grant-attributes-base'


export class CEViewGrantAttributes extends CEViewGrantAttributesBase {

}